import React from 'react'
import UploadTemporaryPopup from './ui/UploadTemporaryPopup'
import cls from './CreateNewTemporaryPost.module.sass'
import { openMenu } from '../../../../store/common/commonSlice'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../store/rootReducer'
import { useTranslation } from 'react-i18next'

const CreateNewTemporaryPost = ({ handleUpdateList }: { handleUpdateList: () => void }) => {
    const [t] = useTranslation()

    const dispatch = useDispatch()
    const loggedIn = useSelector((state: RootState) => state.member.loggedIn)
    const [isUploadPopupOpen, setIsUploadPopupOpen] = React.useState(false)
    const handleOpenCreateTemporaryPost = () => {
        if (!loggedIn) {
            dispatch(openMenu())
            return
        }
        setIsUploadPopupOpen(true)
    }

    return (
        <>
            <div className={cls['createNewTemporaryPostContainer']}>
                <div className={cls['createNewTemporaryPost']} onClick={handleOpenCreateTemporaryPost}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                        <path fill="#104283" d="M0 8V6h6V0h2v6h6v2H8v6H6V8z" />
                    </svg>
                    <span>{t('Create ephemeral story')}</span>
                </div>
                <div className={cls['updateList']} onClick={handleUpdateList}>
                    <svg width="18px" height="18px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M3 3V9M3 9H9M3 9L5.64028 6.63067C7.02129 5.25209 8.81296 4.35964 10.7453 4.08779C12.6777 3.81593 14.6461 4.17941 16.3539 5.12343C18.0617 6.06746 19.4164 7.54091 20.2139 9.32177M21 21V15M21 15L15 15M21 15L18.3597 17.3693C16.9787 18.7479 15.187 19.6404 13.2546 19.9122C11.3223 20.1841 9.3539 19.8206 7.64609 18.8766C5.93828 17.9325 4.58355 16.4591 3.78603 14.6782"
                            stroke="#104283"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <span>{t('Reload')}</span>
                </div>
            </div>
            {isUploadPopupOpen && loggedIn && <UploadTemporaryPopup onClose={() => setIsUploadPopupOpen(false)} />}
        </>
    )
}

export default CreateNewTemporaryPost
